import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import {
  Modal, Button,
  ModalHeader,
  ModalBody,
  Col,
  Label,
} from "reactstrap";
import {
  AvForm, AvField,
  AvCheckbox,
  AvCheckboxGroup,
  AvRadio,
  AvRadioGroup, 
} from "availity-reactstrap-validation";
import Loader from "components/Common/Loader";
import useModal from "hooks/useModal";
import AvFieldSelect from "components/Common/AvFieldSelect";
import { validateFile } from "pages/Transactions/Crypto/AddDepositForm";
import { addBonus } from "store/bonus/actions";
import { fetchAccountTypes } from "store/actions";


const ClientType = ["LIVE"];
const PROCESS = ["Deposit", "Welcome", "Lot"];
const ACCOUNTGROUP = ["Executive MT4", "Executive MT5"];
const BONUSTYPE = ["DEPOSIT", "CREDIT_LOSE_APLE", "CREDIT_UNLOSE_APLE", ];


function AddBonus(props) {
  const dispatch = useDispatch();

  const [showModal, toggleModal] = useModal(false);
  const [accountGroup, setAccountGroup] = useState([]);
  const [bonusType, setBonusType] = useState([]);
  const [file, setFile] = useState({});
  const [process, setProcess] = useState();
  const [bonusPercentage, setBonusPercentage] = useState(false);
  const [bonusDuration, setBonusDuration] = useState(false);
  const [submissionSuccess, setSubmissionSuccess] = useState(false);
  const create = useSelector((state) => state.Profile?.AccTypesPermissions?.create);

  const { accountTypes, submitting, error } = useSelector((state) => state.tradingAccountReducer);
  
  // Modified useEffect to only close modal on successful submission
  useEffect(() => {
    if (!submitting && !error && showModal && submissionSuccess) {
      toggleModal();
      setSubmissionSuccess(false); // Reset for next time
    }
  }, [submitting, error]);
  
  useEffect(()=>{loadAccountTypes}, []);

  const loadAccountTypes = () => {
    dispatch(fetchAccountTypes());
  };
  

  const handleSubmit = (e, v) => {
    e.preventDefault();
    setSubmissionSuccess(true); // Mark that we're attempting a submission

    const formData = new FormData();
    formData.append("bonusName", v.bonusName);
    formData.append("process", v.process);
    formData.append("clientType", v.clientType);
    formData.append("banner", file);

    formData.append("accountGroup",  v.accountGroup.title);
    formData.append("bonusType", v.bonusType);
    formData.append("amount", parseFloat(v.amount ?? 0));
    if (bonusPercentage) {
      formData.append("maxAmount", parseFloat(v.maxAmount ?? 0));
    }
    formData.append("accountType", v.accountGroup._id);
    if (process === "Deposit") {
      formData.append("bonusLimit", parseInt(v.bonusLimit));
    }
    formData.append("desc", v.desc);       
    formData.append("isPercentage", bonusPercentage);  
    formData.append("percentage", parseFloat(v.percentage ?? 0));
    formData.append("isPublic", v.isPublic);
    if (v.dateFrom && v.dateTo) {
      formData.append("dateFrom", v.dateFrom);
      formData.append("dateTo", v.dateTo);
    }
    if (process === "Lot") {
      formData.append("lotLimit", v.lotLimit);
    }
  
    dispatch(addBonus(formData));
    toggleModal(); // Close modal after submission
  };

  // Handle form validation errors
  const handleInvalidSubmit = (event, errors, values) => {
    setSubmissionSuccess(false); // Don't close modal on validation errors
    console.log("Form validation errors:", errors);
  };
  
  return (
    <>
      <Link to="#" className={`btn btn-primary ${!create ? "d-none" : ""}`} onClick={toggleModal}><i className="bx bx-plus me-1"></i> Add New Bonus</Link>
      <Modal isOpen={showModal} toggle={toggleModal} centered={true}>
        <ModalHeader toggle={toggleModal} tag="h4">
          Add New Bonus
        </ModalHeader>
        <ModalBody >
          <AvForm
            className='px-4'
            onValidSubmit={(e, v) => { handleSubmit(e, v) }}
            onInvalidSubmit={handleInvalidSubmit}
          >
            <AvField
              name="bonusName"
              label="Bonus Name"
              placeholder="Bonus Name "
              type="text"
              validate={{
                required: {
                  value: true,
                  errorMessage: "Bonus Name is required"
                }
              }}
            />
            <AvFieldSelect
              name="process"
              label="Process"
              placeholder="Select Process"
              options={PROCESS?.map((type) => ({
                value: type,
                label: type
              }))}
              value={process}
              onChange={(e) => setProcess(e)}
              validate={{
                required: {
                  value: true,
                  errorMessage: "Type is required"
                }
              }}
            />
            {process === "Lot" && (
              <div className="d-flex  position-relative">
                <div className="position-relative w-100">
                  <AvField
                    name="lotLimit"
                    label={props.t("Lot Limit")}
                    placeholder={props.t("Enter Lot Limit")}
                    type={"number"}
                    min={0}
                    max={ 100 }
                    onKeyPress={(e) => {
                      if (!isNaN(e.key) && e.target.value.length > 0) {
                        return true;
                      }
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    validate={{
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "max percentage is 100"
                      },
                    }}
                  />
                </div>
              </div>  
            )}
            {
              <AvFieldSelect
                name="clientType"
                label="Client Type"
                placeholder="Select Client Type"
                options={ClientType.map((type) => ({
                  value: type,
                  label: type
                }))}
                validate={{
                  required: {
                    value: true,
                    errorMessage: "Client Type is required"
                  }
                }}
              />
              
            }
            <div className="mb-3">
              {/* image */}
              <Col md="12">
                <Label className="form-label" htmlFor="banner">
                  {props.t("Banner")}
                </Label>
                <AvField
                  type="file"
                  name="banner"
                  className="form-control form-control-md"
                  errorMessage={props.t("Banner is required")}
                  onChange={(e) => {
                    setFile(e.target.files[0]);
                  }}
                  validate={{
                    required: { value: true },
                    validate: validateFile(["jpg", "jpeg", "png"], 1000000, file, {
                      sizeValidationMessage: props.t("The file size is too large"),
                      extensionValidationMessage: props.t("The file extension is not allowed"),
                    })
                  }}
                />
              </Col>
            </div>
            <div className="fs-3">
              <AvRadioGroup  inline name="isPublic" label={<span style={{ 
                fontSize: "1rem",
                fontWeight: "bold"
              }}></span>} validate={{
                required: {
                  value: true,
                  errorMessage: "status is required"
                }
              }} >
                <AvRadio label="Public" value="true" />
                <AvRadio label="Private" value="false"  />
              </AvRadioGroup>
            </div>

            {<p   className="text-danger ">*only images </p>}
            <AvFieldSelect
              name="accountGroup"
              label="Account Group"
              placeholder="Select Account Group Options"
              options={accountTypes?.filter((type) => type.type === "LIVE")?.map((type) => ({
                value: type,
                label: type.title
              }))}
              onChange={(e) => {
                setAccountGroup(e);
              }}
              validate={{
                required: {
                  value: true,
                  errorMessage: "Account Group options is required"
                }
              }}
            />
            
            <AvFieldSelect
              name="bonusType"
              label="Bonus Type"
              placeholder="Select Bonus Type"
              options={BONUSTYPE.map((type) => ({
                value: type,
                label: type
              }))}
              onChange={(e) => {
                setBonusType(e);
              }}
              validate={{
                required: {
                  value: true,
                  errorMessage: "Bonus Type is required"
                }
              }}
            />
            {
              process !== "Lot" && (
                <div className="fs-3">
                  <AvRadioGroup  inline name="isPercentage" label={<span style={{ 
                    fontSize: "1rem",
                    fontWeight: "bold"
                  }}></span>} validate={{
                    required: {
                      value: true,
                      errorMessage: "percentage is required"
                    }
                  }} >
                    <AvRadio label="Percentage" value="true"  onClick={()=> setBonusPercentage(true)}/>
                    <AvRadio label="Fixed Amount" value="false" onClick={()=> setBonusPercentage(false)} />
                  </AvRadioGroup>
                </div>
              )
            }

            {bonusPercentage === false && (
              <div className="mb-3 d-flex  position-relative">
                <div className="position-relative w-100">
                  <AvField
                    name="amount"
                    label={props.t("Amount")}
                    placeholder={props.t("Enter Amount")}
                    type={process === "Welcome" ? "text" : "number"}
                    min={0}
                    max={process === "Deposit" ? 100 : 1000000000}
                    onKeyPress={(e) => {
                      if (!isNaN(e.key) && e.target.value.length > 0) {
                        return true;
                      }
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    validate={{
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "testing error message"
                      },
                    }}
                  />
                </div>
              </div>  
            )}
            {bonusPercentage === true && process !== "Lot" ? <>
              <div className="mb-3 d-flex  position-relative">
                <div className="position-relative w-100">
                  <AvField
                    name="percentage"
                    label={props.t("Percentage")}
                    placeholder={props.t("Enter Percentage")}
                    type={"number"}
                    min={0}
                    max={ 90000 }
                    onKeyPress={(e) => {
                      if (!isNaN(e.key) && e.target.value.length > 0) {
                        return true;
                      }
                      if (!/[0-9]/.test(e.key)) {
                        e.preventDefault();
                      }
                    }}
                    validate={{
                      pattern: {
                        value: "^[0-9]+$",
                        // errorMessage: "max percentage is 100"
                      },
                    }}
                  />
                </div>
              </div>  
              <div className="mb-3">
                <AvField
                  name="maxAmount"
                  label={props.t("Max Amount")}
                  placeholder={props.t("Enter Max Amount")}
                  type="text"
                  onKeyPress={(e) => {
                    if (!isNaN(e.key) && e.target.value.length > 0){
                      return true;
                    }
                    if (!/[0-9]/.test(e.key)) {
                      e.preventDefault();
                    }
                  }}
                  validate={
                    {
                      pattern: {
                        value: "^[0-9]+$",
                        errorMessage: "testing error message"
                      },
                    }
                  }
                />
              </div>
            </>
              : ""}
            <div className="fs-3">

              <AvRadioGroup  inline name="any" label={<span style={{ 
                fontSize: "1rem",
                fontWeight: "bold"
              }}></span>} validate={{
                required: {
                  value: true,
                  errorMessage: "percentage is required"
                }
              }} >
                <AvRadio label="All Time" value="true"  onClick={()=> setBonusDuration(false)}/>
                <AvRadio label="Duration" value="false" onClick={()=> setBonusDuration(true)} />
              </AvRadioGroup>
            </div>
            { bonusDuration && (
              <div>
                <AvField
                  name="dateFrom"
                  label={props.t("Date From")}
                  type="date"
                  errorMessage={props.t("Select date From")}
                  // validate={{ required: { value: true } }}
                />
                <AvField
                  name="dateTo"
                  label={props.t("Date To")}
                  type="date"
                  errorMessage={props.t("Select date To")}
                  // validate={{ required: { value: true } }}
                />
              </div>
            )}
            {
              process === "Deposit" && (
                <AvField
                  name="bonusLimit"
                  label="Bonus Limit Per Account"
                  placeholder="Bonus Limit Per Account "
                  type="number"
                  min={1}
                /> )
            }
            <AvField
              name="desc"
              label="Desc"
              placeholder="Desc "
              type="textarea"
              validate={{
                required: {
                  value: true,
                  errorMessage: "Desc  is required"
                }
              }}
            />
            <div className='text-center mt-3 p-2'>
              {
                submitting
                  ? <Loader />
                  : <Button disabled={props.addLoading} type="submit" color="primary">
                    Add
                  </Button>
              }
            </div>
          </AvForm>
        </ModalBody>
      </Modal>
    </>
  );
}

export default AddBonus;